import { Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import logoBlack from '@/assets/logo-black.svg'
import { Button } from '@/components/ui/button'
import { useCurrentLang } from '@/shared/i18n/use-current-lang'

/**
 * Start-page header: a floating pill with the same translucency as the
 * login/signup header (AuthForm), so the constellation shows through.
 */
export function GtmLandingHeader() {
  const { t } = useTranslation('gtm')
  const lang = useCurrentLang()

  return (
    <header className="flex items-center justify-between gap-2 rounded-xl border border-sidebar-border bg-background/35 px-3 py-2.5 text-sidebar-foreground backdrop-blur-[2px] sm:gap-3 sm:rounded-2xl sm:px-6 sm:py-3">
      <Link
        to="/$lang"
        params={{ lang }}
        aria-label={t('brand')}
        className="flex min-w-0 items-center gap-1.5"
      >
        <img src={logoBlack} alt="" className="h-6 w-auto sm:h-8" />
        <span className="truncate text-sm font-semibold text-foreground sm:text-lg">
          {t('brand')}
        </span>
      </Link>
      <Button
        asChild
        variant="ghost"
        size="sm"
        className="h-11 shrink-0 rounded-xl px-2.5 sm:px-4"
      >
        <Link to="/$lang/login" params={{ lang }}>
          {t('login')}
        </Link>
      </Button>
    </header>
  )
}
